module.exports = __webpack_public_path__ + "img/icon_society_white.d6adc55a.jpg";